import React from 'react'
import { Button, ButtonType, ButtonSize } from '@wallyhealth/web-core'
import PageTemplate from '../PageTemplate'
import styles from './index.module.css'

const ErrorPageTemplate = ({ title = 'Something went wrong.', description, ctaLabel, ctaHandler }) => (
  <PageTemplate>
    <div className={styles.content}>
      <div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        {ctaHandler && (
          <Button
            type={ButtonType.DEFAULT}
            size={ButtonSize.LARGE}
            label={ctaLabel || 'Try Again'}
            onClick={ctaHandler}
          />
        )}
      </div>
    </div>
  </PageTemplate>
)

export default ErrorPageTemplate
